import * as defaultImport from "@splunk/visualizations/NetworkGraph";
export * from "@splunk/visualizations/NetworkGraph";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
